export function parseAmount(value: string): number {
  if (!value) return 0;
  const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function hasAmount(value: string): boolean {
  return value.trim() !== '' && Number.isFinite(parseFloat(value.replace(/[^0-9.-]/g, '')));
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/** Formats the raw input string into a grouped, 2-decimal amount for display on blur. */
export function formatAmountInput(value: string): string {
  if (!hasAmount(value)) return '';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseAmount(value));
}

export function toDecimalString(value: number): string {
  if (!Number.isFinite(value)) return '';
  return value.toFixed(2);
}
